import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";

const LineTruncate = styled.div`
  display: table;
  table-layout: fixed;
  width: ${props => props.width || "100%"};
  white-space: nowrap;
  text-align: ${props => props.textAlign || "left"};

  > * {
    display: table-cell;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

const types = {
  width: PropTypes.string,
  textAlign: PropTypes.string,
  children: PropTypes.node
};
LineTruncate.propTypes = types;

export default LineTruncate;

//Only used for the Storybook Props Table
export const WithProps = ({ children, ...props }) => (
  <LineTruncate {...props}>{children}</LineTruncate>
);

WithProps.propTypes = types;
